import { createNotification } from "react-redux-notify";
import { put, takeLatest, all } from "redux-saga/effects";

import {
  replaceMessage,
  newConversationSuccess,
  newConversationFailure,
  fetchChatMessageSuccess,
  fetchChatMessageFailure,
  fetchUserChatroomsFailure,
  fetchUserChatroomsSuccess,
  deleteConversationSuccess,
  deleteConversationFailure,
  unlockMessagePaymentSuccess,
  unlockMessagePaymentFailure,
  fetchBulkSendMetadataSuccess,
  fetchBulkSendMetadataFailure,
  fetchBulkSendUserSuccess,
  fetchBulkSendUserFailure,
  setUnreadMessageCount
} from "../actions/ChatAction";
import {
  NEW_CONVERSATION_START,
  START_CONVERSATION_START,
  FETCH_CHAT_MESSAGE_START,
  DELETE_CONVERSATION_START,
  GET_BULK_SEND_USERS_START,
  FETCH_USER_CHATROOMS_START,
  GET_BULK_SEND_METADATA_START,
  UNLOCK_MESSAGE_PAYMENT_START,
  FETCH_UNREAD_MESSAGE_AND_NOTIFICATION_COUNT,
} from "../actions/ActionConstant";
import ErrorUtils from "../../helpers/utils/errors";
import { fetchWalletDetailsStart } from "../actions/WalletAction";
import UserService from "../../helpers/services/communication/user";
import MessageService from "../../helpers/services/communication/message";
import ChatroomService from "../../helpers/services/communication/chatroom";
import { fetchNotificationBellCountSuccess } from "../actions/NotificationAction";
import { hideErrorComponent, showErrorComponent } from "../actions/ComponentAction";
import { getErrorNotificationMessage, } from "../../components/helper/NotificationMessage";

function* newConverstaion(action) {
  try {
    const response = yield UserService.newConverstaion(action?.data);
    yield put(newConversationSuccess(response));
    yield put(hideErrorComponent());
  } catch (error) {
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const { notify, message } = ErrorUtils.handleCommunicationError(error.response)
    yield put(newConversationFailure(message));
    if (notify) {
      yield put(createNotification(getErrorNotificationMessage(message)));
    }
  }
}

function* deleteConverstaion(action) {
  try {
    const response = yield ChatroomService.deleteChatroom(action?.data);
    yield put(deleteConversationSuccess(response));
    yield put(hideErrorComponent());
    window.location.assign('/inbox')
  } catch (error) {
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const { notify, message } = ErrorUtils.handleCommunicationError(error.response)
    yield put(deleteConversationFailure(message));
    if (notify) {
      yield put(createNotification(getErrorNotificationMessage(message)));
    }
  }
}

function* startConverstaion(action) {
  try {
    const { user_id, member_id, onSuccess } = action?.data
    const response = yield ChatroomService.startChatroom(user_id, member_id)
    yield put(newConversationSuccess(response));

    if (onSuccess) {
      onSuccess(response)
      yield put(hideErrorComponent());
    }
  } catch (error) {
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const { notify, message } = ErrorUtils.handleCommunicationError(error.response)
    yield put(newConversationFailure(message));
    if (notify) {
      yield put(createNotification(getErrorNotificationMessage(message)));
    }
  }
}

function* fetchUserChatrooms(action) {
  try {
    const response = yield ChatroomService.fetchChatrooms(action.data);
    yield put(fetchUserChatroomsSuccess(response));
    yield put(hideErrorComponent());
  } catch (error) {
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const { notify, message } = ErrorUtils.handleCommunicationError(error.response)
    yield put(fetchUserChatroomsFailure(message));
    if (notify) {
      yield put(createNotification(getErrorNotificationMessage(message)));
    }
  }
}

function* fetchChatroomMessages(action) {
  try {
    const response = yield MessageService.fetchChatroomMessages(action.data.chatroom_id, action.data.page, action.data.limit);
    yield put(fetchChatMessageSuccess(response));
    yield put(hideErrorComponent());
  } catch (error) {
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const { notify, message } = ErrorUtils.handleCommunicationError(error.response)
    yield put(fetchChatMessageFailure(message));
    if (notify) {
      yield put(createNotification(getErrorNotificationMessage(message)));
    }
  }
}

function* fetchUnreadMessageAndNotificationCount(action) {
  try {
    const response = yield MessageService.fetchUnreadMessageAndNotificationCount()
    yield put(setUnreadMessageCount(response.unread_messages))
    yield put(fetchNotificationBellCountSuccess({
      count: response.unread_notification
    }))
  } catch (error) {
    const { notify, message } = ErrorUtils.handleCommunicationError(error.response)
    if (notify) {
      yield put(createNotification(getErrorNotificationMessage(message)));
    }
  }
}

function* unlockChatroomMessage(action) {
  try {
    const response = yield MessageService.unlockChatroomMessage(action.data.message_id);
    yield put(replaceMessage(response))
    yield put(fetchWalletDetailsStart())
    yield put(unlockMessagePaymentSuccess(response));
    yield put(hideErrorComponent());
  } catch (error) {
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const { notify, message } = ErrorUtils.handleCommunicationError(error.response)
    yield put(unlockMessagePaymentFailure(message));
    if (notify) {
      yield put(createNotification(getErrorNotificationMessage(message)));
    }
  }
}

function* bulkSendUsers(action) {
  try {
    const response = yield UserService.fetchBulkSendUsers(action.data)
    yield put(fetchBulkSendUserSuccess(response));
    yield put(hideErrorComponent());
  } catch (error) {
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const { notify, message } = ErrorUtils.handleCommunicationError(error.response)
    yield put(fetchBulkSendUserFailure(message));
    if (notify) {
      yield put(createNotification(getErrorNotificationMessage(message)));
    }
  }
}

function* bulkSendMetadata() {
  try {
    const response = yield ChatroomService.fetchBulkSendMetadata();
    yield put(fetchBulkSendMetadataSuccess(response));
    yield put(hideErrorComponent());
  } catch (error) {
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const { notify, message } = ErrorUtils.handleCommunicationError(error.response)
    yield put(fetchBulkSendMetadataFailure(message));
    if (notify) {
      yield put(createNotification(getErrorNotificationMessage(message)));
    }
  }
}

export default function * pageSaga() {
  yield all([yield takeLatest(NEW_CONVERSATION_START, newConverstaion)]);
  yield all([yield takeLatest(GET_BULK_SEND_USERS_START, bulkSendUsers)]);
  yield all([yield takeLatest(START_CONVERSATION_START, startConverstaion)]);
  yield all([yield takeLatest(DELETE_CONVERSATION_START, deleteConverstaion)]);
  yield all([yield takeLatest(FETCH_USER_CHATROOMS_START, fetchUserChatrooms)]);
  yield all([yield takeLatest(GET_BULK_SEND_METADATA_START, bulkSendMetadata)]);
  yield all([yield takeLatest(FETCH_CHAT_MESSAGE_START, fetchChatroomMessages)]);
  yield all([yield takeLatest(UNLOCK_MESSAGE_PAYMENT_START, unlockChatroomMessage)]);
  yield all([yield takeLatest(FETCH_UNREAD_MESSAGE_AND_NOTIFICATION_COUNT, fetchUnreadMessageAndNotificationCount)])
  
}
